module.exports = __webpack_public_path__ + "media/startsida.881bfa4c.mp4";